












import { Component, Vue, Prop } from 'vue-property-decorator';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import VHeader from '../components/sub-header.vue';
import VTable from '../components/table.vue';
import { NcovDataType } from '../types';
import { util, biHottag, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import LoadFailed from '@/components/load-failed.vue';

@Component({
  components: { VHeader, VTable, LoadFailed },
})
export default class AreaTable extends Vue {
  loadFailed = false;
  lang = language.getLanguage();
  tabelCols = [
    {
      title: i18n('化驗所名稱'),
      key: 'name',
      width: '30%',
      color: '#373737',
    },
    {
      title: i18n('查詢電郵'),
      key: 'email',
      width: '30%',
      color: '#373737',
    },
    {
      title: i18n('查詢電話 '),
      key: 'tel',
      width: '20%',
      color: '#373737',
    },
    {
      title: i18n('網站'),
      key: 'website',
      width: '20%',
      color: '#373737',
    },
  ];

  tabelData = [
    {
      name_en: 'BGI',
      name: '華大基因',
      website: 'N/A',
      email: 'info@bgi.com',
      tel: '2818 9690',
    },

    {
      name_en: 'Canossa Hospital (Caritas)',
      name: '嘉諾撒醫院',
      website: 'https://www.canossahospital.org.hk/tc/',
      email: 'opd@canossahospital.org.hk',
      tel: '5544 9183',
    },

    {
      name_en: 'Chan & Hou Medical Laboratories Ltd',
      name: '香港(CH)病理檢驗中心',
      website: 'N/A',
      email: 'covid19@chlab.com.hk',
      tel: '2522 1860',
    },

    {
      name_en: 'Diagnostix Medical Centre Ltd',
      name: '健康化驗中心有限公司',
      website: 'N/A',
      email: 'covid_enquiry@diagnostix.com.hk',
      tel: '2885 4686',
    },

    {
      name_en: 'Gleneagles Hospital Hong Kong Clinical Laboratory',
      name: '港怡醫院臨床病理學',
      website: 'https://gleneagles.hk/',
      email: 'enquiry@gleneagles.hk',
      tel: '2122 1333',
    },

    {
      name_en: 'Hong Kong Adventist Hospital – Tsuen Wan ',
      name: '香港港安醫院–荃灣',
      website: 'https://www.twah.org.hk/en/main',
      email: 'lab.dept@twah.org.hk',
      tel: '2275 6166',
    },

    {
      name_en: 'Hong Kong AdventistHospital – Stubbs Road',
      name: '香港港安醫院–司徒拔道',
      website: 'https://www.hkah.org.hk/en/main ',
      email: 'claboratory@hkah.org.hk',
      tel: '2835 0534',
    },

    {
      name_en: 'Hong Kong Baptist Hospital – Molecular Pathology',
      name: '香港浸信會醫院–分子病理學',
      website: 'https://www.hkbh.org.hk/',
      email: 'info@hkbh.org.hk',
      tel: '2339 8941',
    },

    {
      name_en: 'HKMPDC / HongKong Molecular Pathology Diagnostic Centre Limited',
      name: '香港分子病理檢驗中心有限公司',
      website: 'https://www.hkmpdc.com/main.php',
      email: 'contact@hk-mpdc.com',
      tel: '2986 1272',
    },

    {
      name_en: 'Hong Kong Sanatorium & Hospital Molecular Pathology Division',
      name: '香港養和醫院分子病理部',
      website: 'https://www.hksh.com/',
      email: 'covid@hksh-hospital.com',
      tel: '2835 8602',
    },

    {
      name_en: 'Kingmed Diagnostics (Hong Kong) Limited',
      name: '金域檢驗(香港)有限公司',
      website: 'N/A',
      email: 'sales@kingmed.com.hk',
      tel: '2919 7222',
    },

    {
      name_en: 'Modern Genomic Services Limited',
      name: '現代基因技術有限公司',
      website: 'https://www.moderngenomic.com/',
      email: 'info@moderngenomic.com',
      tel: '3604 1305',
    },

    {
      name_en: 'PathLab Medical Laboratories Ltd',
      name: '栢立醫學化驗室',
      website: 'http://www.pathlabhk.com/covid/covid.html',
      email: 'covid.info@pathlabhk.com',
      tel: '3983 1800',
    },

    {
      name_en: 'Prenetics ',
      name: 'Prenetics ',
      website: 'https://projectscreen.co/',
      email: 'projectscreen@prenetics.com',
      tel: '3008 8323',
    },

    {
      name_en: 'St. Teresa Hospital – Clinical Laboratory',
      name: '聖德肋撤醫院臨床病理檢驗部',
      website: 'http://www.sth.org.hk/',
      email: 'sth@sth.org.hk',
      tel: '2711 9335',
    },

    {
      name_en: 'Union Hospital Pathology Department',
      name: '仁安醫院病理部',
      website: 'https://www.union.org/',
      email: 'union@union.org',
      tel: '2608 3355',
    },
  ];

  get cols() {
    return this.tabelCols;
  }
  get dataset() {
    return this.tabelData;
  }
  onTelClick() {
    biHottag('wallet.cvirus.testinginst.call_click'); // 疫情首页-核酸机构列表页-电话按钮点击
  }
  onWebsiteClick() {
    biHottag('wallet.cvirus.testinginst.web_click'); // 疫情首页-核酸机构列表页-网站按钮点击
  }
  async activated() {
    showLoading();
    window.scrollTo(0, 0);
    this.loadFailed = false;
    biHottag('wallet.cvirus.testinginst.index_brow'); // 核酸机构列表页

    if (this.lang === 'en') {
      this.tabelData.forEach((item) => {
        item.name = item.name_en;
      });
    }
    hideLoading();
  }
  deactivated() {}
}
